import styles from './ContentOverviewHeaderContainer.module.css';

type ContentOverviewHeaderContainerProps = {
	header?: string;
	subHeader?: string;
	description?: string;
	restrictWidth?: boolean;
};

export default function ContentOverviewHeaderContainer(props: ContentOverviewHeaderContainerProps): JSX.Element {
	if (!props) {
		return <></>;
	}

	return (
		<div className={`${styles.contentOverviewHeaderContainer} ${props.restrictWidth ? styles.restrictedWidth : ''}`}>
			{props.header && <h3 className={styles.header}>{props.header}</h3>}
			{props.subHeader && <p className={styles.subHeader}>{props.subHeader}</p>}
			{props.description && <p className={styles.description}>{props.description}</p>}
		</div>
	);
}
